const STATUS_GROUPS = {
  notStarted: new Set(['', 'not_started', 'assigned']),
  inProgress: new Set(['started', 'working', 'in_progress']),
  approvalPending: new Set(['waiting_review', 'waiting_approval', 'approval_pending', 'work_submitted']),
  revision: new Set(['revision', 'revision_in_progress', 'under_revision']),
  completed: new Set(['completed', 'delivered'])
};

const parseDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getArchitectProjectStatus = (project = {}) => (
  String(project.architect_task_status || '').trim().toLowerCase()
);

export const getArchitectProjectDueDate = (project = {}) => parseDate(
  project.architect_due_date || project.due_date || project.expected_start_date
);

export const getArchitectAssignmentDate = (project = {}) => parseDate(
  project.architect_assigned_at || project.assigned_at || project.assignment_date ||
  project.assigned_date
);

export const isArchitectProjectDelayed = (project, now = new Date()) => {
  const dueDate = getArchitectProjectDueDate(project);
  const status = getArchitectProjectStatus(project);
  return Boolean(dueDate && dueDate.getTime() < now.getTime() && !STATUS_GROUPS.completed.has(status));
};

export const formatTimeSinceAssignment = (project, now = new Date()) => {
  const assignedAt = getArchitectAssignmentDate(project);
  if (!assignedAt) return 'Not recorded';

  const elapsedMs = Math.max(0, now.getTime() - assignedAt.getTime());
  const totalHours = Math.floor(elapsedMs / (60 * 60 * 1000));
  const days = Math.floor(totalHours / 24);
  const hours = totalHours % 24;
  return `${days}d ${hours}h`;
};

export const getArchitectMetrics = (projects = [], now = new Date()) => projects.reduce((metrics, project) => {
  const status = getArchitectProjectStatus(project);
  metrics.total += 1;
  if (STATUS_GROUPS.notStarted.has(status)) metrics.notStarted += 1;
  if (STATUS_GROUPS.inProgress.has(status)) metrics.inProgress += 1;
  if (STATUS_GROUPS.approvalPending.has(status)) metrics.approvalPending += 1;
  if (STATUS_GROUPS.revision.has(status)) metrics.revision += 1;
  if (STATUS_GROUPS.completed.has(status)) metrics.completed += 1;
  if (isArchitectProjectDelayed(project, now)) metrics.delayed += 1;
  if (String(project.priority || '').toLowerCase() === 'urgent') metrics.urgent += 1;
  return metrics;
}, {
  total: 0,
  notStarted: 0,
  inProgress: 0,
  approvalPending: 0,
  revision: 0,
  delayed: 0,
  urgent: 0,
  completed: 0
});
